// extracted by mini-css-extract-plugin
export default {"FotterFrame":"Fotter_FotterFrame__I0iJL"};